// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"00c8aa4b","52":"ffaeec56","86":"51c65add","367":"a680412f"}[chunkId] + ".css";
};